export const NOTIFICATIONS_CLEAR_NOTIFICATIONS = 'NOTIFICATIONS_CLEAR_NOTIFICATIONS'
export const NOTIFICATIONS_FETCH_NOTIFICATIONS = 'NOTIFICATIONS_FETCH_NOTIFICATIONS'
export const NOTIFICATIONS_MARK_NOTIFICATION_AS_READ = 'NOTIFICATIONS_MARK_NOTIFICATION_AS_READ'
export const NOTIFICATIONS_QUEUE_FOR_MARK_AS_READ = 'NOTIFICATIONS_QUEUE_FOR_MARK_AS_READ'
export const NOTIFICATIONS_TOGGLE_NOTIFICATIONS_LIST = 'NOTIFICATIONS_TOGGLE_NOTIFICATIONS_LIST'
export const NOTIFICATIONS_UPDATE_NOTIFICATION_COUNT = 'NOTIFICATIONS_UPDATE_NOTIFICATION_COUNT'
